const ACCESS_DEVICE_NAME_MAP = {
  auxiliaryInputs: 'Aux In',
  auxiliaryOutputs: 'Aux Out',
  contacts: 'Contact',
  doorOpeners: 'Door Opener',
  locks: 'Lock',
  readers: 'Reader',
  rexs: 'Request to Exit',
  tampers: 'External Tamper'
}

export default keyStr => ACCESS_DEVICE_NAME_MAP[keyStr]



// WEBPACK FOOTER //
// ./src/helpers/accessControl/deviceTypeName.js